import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import AbgasskandalFragebogen from '../views/abgasskandal/Fragebogen.vue'
import AbgasskandalErstberatung from '../views/abgasskandal/kostenlose-Erstberatung.vue'
import AbgasErstberatungAnfordern from '../views/abgasskandal/kostenlose-erstberatung-anfordern.vue'
import AnwaltsschreibenBeantragen from '../views/anwaltsschreiben/anwaltsschreiben-beantragen.vue'
import ArbeitsrechtVollmachtserteilung from '../views/arbeitsrecht/vollmachtserteilung.vue'
import AufhebungsvertragPaypal from '../views/arbeitsrecht/aufhebungsvertrag-paypal.vue'

import BetriebsschliessungErstberatung from '../views/betriebsschliessung/kostenlose-erstberatung.vue'
import FilesharingFragebogen from '../views/filesharing/Fragebogen.vue'
import KreditwiderrufVollmachtserteilung from '../views/vfe-kreditwiderruf/vollmachtserteilung.vue'
import PkvFrageboden from '../views/pkv/Fragebogen.vue'
import PkvDatenvervollstaendigung from '../views/pkv/Datenvervollstaendigung'

import OnlineCasinoVollmachtserteilung from '../views/online-casino/vollmachtserteilung'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/abgasskandal/fragebogen',
		name: 'Abgasskandal Fragebogen',
		component: AbgasskandalFragebogen
	},
	{
		path: '/private-krankenversicherung/fragebogen',
		name: 'Private Krankenversicherung Fragebogen',
		component: PkvFrageboden
	},
	{
		path: '/private-krankenversicherung/datenvervollstaendigung',
		name: 'Private Krankenversicherung Datenvervollständigung',
		component: PkvDatenvervollstaendigung
	},
	{
		path: '/abgasskandal/kostenlose-Erstberatung',
		name: 'Abgasskandal - kostenlose Erstberatung',
		component: AbgasskandalErstberatung
	},
	{
		path: '/abgasskandal/kostenlose-erst-beratung',
		name: 'Abgasskandal - Kostenlose Erstberatung',
		component: AbgasErstberatungAnfordern
	},
	{
		path: '/filesharing/fragebogen',
		name: 'Filesharing Fragebogen',
		component: FilesharingFragebogen
	},
	{
		path: '/anwaltsschreiben/anwaltsschreiben-beantragen',
		name: 'Anwaltsschreiben - Beantragung',
		component: AnwaltsschreibenBeantragen
	},
	{
		path: '/betriebsschliessung/kostenlose-Erstberatung',
		name: 'Betriebsschließung - Kostenlose Erstberatung',
		component: BetriebsschliessungErstberatung
	},
	{
		path: '/arbeitsrecht/vollmachtserteilung',
		name: 'Vollmachtserteilung',
		component: ArbeitsrechtVollmachtserteilung
	},
	{
		path: '/vfe-kreditwiderruf/vollmachtserteilung',
		name: 'KreditwiderrufVollmachtserteilung',
		component: KreditwiderrufVollmachtserteilung
	},
	{
		path: '/arbeitsrecht/aufhebungsvertrag',
		name: 'Aufhebungsvertrag',
		component: AufhebungsvertragPaypal
	},
	{
		path: '/online-casino/vollmachtserteilung',
		name: 'OnlineCasinoVollmachtserteilung',
		component: OnlineCasinoVollmachtserteilung
	}
]

const router = new VueRouter({
	mode: 'history',
	routes
})

export default router
